var render = function render(){var _vm=this,_c=_vm._self._c;return _c('format',{attrs:{"msg":_vm.$t('online-football'),"type-game":3,"src":require('@/assets/nav/submenu/icon_submenu16.svg')}},[_c('v-row',{staticClass:"toolbartab pa-3",attrs:{"no-gutters":""}},[_c('h5',[_c('mark',{staticClass:"red--text"},[_vm._v(" *** "+_vm._s(_vm.$t('desc.external-game-football-detail'))+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }